export type InterviewStatus = "pending" | "inprogress" | "expired" | "completed" | "interrupted";

export interface Interview {
  id: string;
  jobId: string;
  firstName: string;
  lastName: string;
  email: string;
  createdDate: string;
  completedDate?: string;
  status: InterviewStatus;
  expiryDate: string;
  reportName?: string;
  reportFormat?: string;
  interviewUrl: string; // Generated by backend
}

export interface PaginationInfo {
  page: number;
  pageSize: number;
  totalPages: number;
  totalCount: number;
}

export interface PaginatedResponse<T> {
  pagination: PaginationInfo;
  data: T[];
}

export interface GetInterviewsParams {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface CreateInterviewRequest {
  jobId: string;
  firstName: string;
  lastName: string;
  email: string;
  expiryDate?: string;
}

export interface ApiValidationError {
  type: string;
  title: string;
  status: number;
  errors: Record<string, string[]>;
}

export class ValidationError extends Error {
  errors: Record<string, string[]>;

  constructor(message: string, errors: Record<string, string[]>) {
    super(message);
    this.name = 'ValidationError';
    this.errors = errors;
  }
}
